module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/urinary_organs-4646b8d08cb9d275c97ac7fdeaa09528.png";